function langToggle() {
  document.querySelectorAll('.lang-menu').forEach(menu => {
    if (menu.classList.contains('hide')) {
      menu.classList.add('show');
      menu.classList.remove('hide');
    } else {
      menu.classList.add('hide');
      menu.classList.remove('show');
    }
  });
}

function changeLangue(lang) {
  const url = new URL(window.location.href);
  url.port = '';
  switch (lang) {
    case 'fr-ca':
      url.hostname = 'qc.tanit.co';
      break;
    case 'en-us':
      url.hostname = 'us.tanit.co';
      break;
    default:
      return;
  }

  url.search = `?lang=${lang}`;
  window.location.replace(url.toString());
}

function getQueryValue(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return null;
}

function getGeoip() {
  const geo = getQueryValue('geo');
  if (geo === 'off' || localStorage.getItem('geo') === 'false') {
    localStorage.setItem('geo', false);
    return false;
  }
  return true;
}

function getLang() {
  const lang = getQueryValue('lang');
  // if (lang === 'en-ca' || localStorage.getItem('geo') === 'false') {  change to hide US store
    if (lang === 'en-us' || lang === 'en-ca' || localStorage.getItem('geo') === 'false') {
    localStorage.setItem('geo', false);
    return false;
  }
  return true;
}

function setLocation() {
  return new Promise((resolve) => {
    const localLocation = localStorage.getItem('location');

    if (localLocation) {
      resolve(localLocation);
    } else {
      fetch('https://location.geoip.workers.dev/')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then((location) => {
          localStorage.setItem('location', location);
          resolve(location);
        })
        .catch((error) => {
          console.error(error);
          resolve('CA');
        });
    }
  });
}

function getLocation() {
  if (getGeoip() && getLang()) {
    let replace;
    setLocation()
      .then((location) => {
        if (location === 'CA-QC') {
          replace = window.location.href.replace('www.tanit.co', 'qc.tanit.co');
          window.location.replace(replace);
        } else if (location.startsWith('US')) {
          replace = window.location.href.replace('www.tanit.co', 'us.tanit.co');
          window.location.replace(replace);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

// getLocation();
